var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',[_c('div',{staticClass:"info row"},[_c('div',{staticClass:"col-12 col-lg-9"},[_c('my-desk')],1),_c('div',{staticClass:"col-12 col-lg-3 text-left"},[_c('sticky-menu',{staticClass:"ml-auto",attrs:{"links":_vm.links}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }